import { RcFile } from "antd/es/upload"

export enum UploadTypes {
  json = 'json',
}

export type CommonUploadProps = {
  title?: string
  subtitle?: string
  icon?: React.ReactNode
  onConfirm: (file: RcFile) => void
  onCancel?: () => void
  onFailedFileValidation?: () => void
  onValidation?: (file: RcFile) => boolean
}

export type UploadJsonProps = CommonUploadProps & {
  type?: UploadTypes.json
}

export type UploadProps = (UploadJsonProps)
